<form [formGroup]="credentialsForm" (ngSubmit)="confirm()">
  <div>
    <app-mensajes [code]="code" [titulo]="titulo" [detalle]="detalle"></app-mensajes>
    <div class="register-photo" style="background-color:rgb(255,255,255);">
      <div class="form-container">
        <div class="image-holder">
          <img src="assets/img/DNM/logo_20.png" class="top-img" style="padding-left: 4.5%; padding-top: 4.5%;">
        </div>
        <div class="form" style="align-self: center!important;">
          <h2 style="text-align: center; color: #313945;"><strong>Reenvío de correo de verificación</strong></h2>
          <div class="input-group">
            <p>El sistema permite reenviar un nuevo correo electrónico de verificación de cuenta para que pueda acceder con su nueva cuenta,
              escriba el correo electrónico con el cual se ha registrado.</p>
          </div>
          <div class="input-group">
            <input type="text" required formControlName="correo" id="correo" autocomplete="off" placeholder="Correo electrónico" pInputText class="ui-inputtext ui-widget">
            <span *ngIf="credentialsForm.get('correo').hasError('pattern')">
                <p-message severity="error" text="Verifique el correo electrónico ingresado"></p-message>
            </span>
          </div>
          <div class="input-wrapper" style="margin-bottom: 1rem;">
            <p-confirmDialog header="Alerta del sistema" icon="pi pi-exclamation-triangle"></p-confirmDialog>
            <button type="submit" style="background-color: #313945;" label="Aceptar" pButton [disabled]="!credentialsForm.valid"></button>
          </div>
        </div>
      </div>
    </div>
    <app-spinner [visible]="visibleSpinner"></app-spinner>
  </div>
</form>
